
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import Router from './routes';
import Header from './components/common/Header';
import { AuthProvider } from './context/AuthContext';
import { useAuth } from './context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css';

const GOOGLE_CLIENT_ID = '796111618291-ilr79mbfv0qigbf6b949s2o2p9tkh9b3.apps.googleusercontent.com';

function AppContent() {
    const { isAuthenticated } = useAuth();
    return (
        <div className="App">
            {isAuthenticated && <Header />}
            <Router />
        </div>
    );
}

function App() {
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <AuthProvider>
                    <AppContent />
                </AuthProvider>
            </ThemeProvider>
        </GoogleOAuthProvider>
    );
}

export default App;
